// extracted by mini-css-extract-plugin
module.exports = {"quickLinks":"_76b0dc2","list":"_4c86824","settings":"_0a83cee"};